/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Prep_MomentInputs */



/**
* | output |
* | --- |
* | "When" |
*
* @param {Notifications_Prep_MomentInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const notifications_prep_moment = /** @type {((inputs?: Notifications_Prep_MomentInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Prep_MomentInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wanneer")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quand")
	return /** @type {LocalizedString} */ ("When")
});